import { gql } from "apollo-boost";

const GET_CHARACTERS_TOTAL = gql`
  query characters {
    characters {
      info {
        count
      }
    }
  }
`;

const GET_CHARACTER = gql`
  query character($id: ID!) {
    character(id: $id) {
      id
      name
      status
      species
      type
      gender
      origin {
        name
      }
      location {
        name
      }
      image
      episode {
        name
      }
      created
    }
  }
`;

export { GET_CHARACTERS_TOTAL, GET_CHARACTER };
